<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'user-received-order.shops' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeId" (selectChange)="navigate()"></hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'user-received-order.data' | transloco }}</small>
              <hx-date-range-select [(ngModel)]="params.date" (selectChange)="navigate()"></hx-date-range-select>
            </div>
          </div>

          <hr>

          <div class="report-title">
            {{ 'reports.user-received-order' | transloco }} {{ 'user-received-order.behind' | transloco }} {{ params.date?.from | date:'dd.MM.yyyy' }} - {{ params.date?.to | date:'dd.MM.yyyy' }}
          </div>
          <br/>
          <div style="overflow-x:auto;">
            <table *ngIf="list.length && !isLoading.list">
              <thead>
              <tr>
                <th class="text-center">{{ 'user-received-order.table.head.name' | transloco }}</th>
                <th class="text-center">{{ 'user-received-order.table.head.delivery' | transloco }}</th>
                <th class="text-center">{{ 'user-received-order.table.head.pickUp' | transloco }}</th>
                <th class="text-center">{{ 'user-received-order.table.head.return' | transloco }}</th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let even = even;let i = index; let r of list">
                <tr>
                  <td>{{ r.userFullname }}</td>
                  <td>{{ r.deliveryAmount }}</td>
                  <td>{{ r.pickupAmount }}</td>
                  <td>{{ r.refundAmount }}</td>
                </tr>
              </ng-container>
              </tbody>
            </table>
          </div>
          <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>
        </div>
      </div>
    </div>
  </div>
</div>
